<template>
  <div class="page-mascot-visual" aria-hidden="true">
    <div class="hero-glow hero-glow--blue"></div>
    <div class="hero-glow hero-glow--violet"></div>
    <MascotLogo />
    <div class="orbit orbit--one"></div>
    <div class="orbit orbit--two"></div>
  </div>
</template>

<script>
import MascotLogo from './MascotLogo.vue'

export default {
  name: 'PageMascotVisual',
  components: {
    MascotLogo
  }
}
</script>
